import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export type UseMyToast = ReturnType<typeof useToast>;
export type UseMyToastServerSide = Record<keyof UseMyToast, () => void>;

// As vue-toastification does not support SSR it is mocked server side with empty methods
export const useMyToast = (): UseMyToast | UseMyToastServerSide => {
    if (import.meta.server) {
        return {
            success() {},
            error() {},
            info() {},
            clear() {},
            updateDefaults() {},
            dismiss() {},
            update() {},
            warning() {},
        };
    }
    return useToast();
};
